import type { PropsWithChildren } from 'react';
// @mui
import Box, { type BoxProps } from '@mui/material/Box';
// hooks
import useResponsive from 'hooks/useResponsive';
// config
import { HEADER, NAV } from 'consts/ui';
// components
import { useSettingsContext } from 'lib/settings';

// ----------------------------------------------------------------------

type Props = BoxProps & {
    readonly spacing?: number;
};

const DashboardOutletWrapper = ({
    sx,
    children,
    spacing: SPACING = 8,
    ...other
}: PropsWithChildren<Props>) => {
    const { themeLayout } = useSettingsContext();

    const isNavHorizontal = themeLayout === 'horizontal';

    const isNavMini = themeLayout === 'mini';

    const isDesktop = useResponsive('up', 'lg');

    if (isNavHorizontal) {
        return (
            <Box
                component="main"
                sx={{
                    pt: `${HEADER.H_MOBILE + SPACING}px`,
                    pb: `${HEADER.H_MOBILE + SPACING}px`,
                    overflowX: 'hidden',
                    ...(isDesktop && {
                        px: 2,
                        pt: `${HEADER.H_DASHBOARD_DESKTOP + 80}px`,
                        pb: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
                    }),
                }}
            >
                {children}
            </Box>
        );
    }

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                py: `${HEADER.H_MOBILE + SPACING}px`,
                overflowX: 'hidden',
                ...(isDesktop && {
                    px: 2,
                    py: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
                    width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
                    ...(isNavMini && {
                        width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
                    }),
                }),
                ...sx,
            }}
            {...other}
        >
            {children}
        </Box>
    );
};

export default DashboardOutletWrapper;
